var _defs, _rect, _rect2, _rect3, _rect4, _path, _circle, _path2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImprisonment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "IC_4L_main",
    x: 21.13,
    y: 5.75,
    width: 3.93,
    height: 6.94,
    rx: 1.96,
    ry: 1.96,
    transform: "rotate(-18.66 23.086 9.2)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "IC_4L_main",
    x: 10.76,
    y: 2.72,
    width: 3.93,
    height: 6.94,
    rx: 1.96,
    ry: 1.96,
    transform: "rotate(60 12.719 6.19)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "IC_4L_main",
    x: 5.01,
    y: 12.48,
    width: 3.93,
    height: 6.94,
    rx: 1.96,
    ry: 1.96
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "IC_4L_main",
    x: 5.01,
    y: 24.49,
    width: 3.93,
    height: 6.94,
    rx: 1.96,
    ry: 1.96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M16.38 4.36l4.27 1.39M9.11 8.32l-1.68 3.21M6.95 20.14l.06 3.63"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 32.19,
    cy: 27.39,
    r: 1.5,
    transform: "rotate(-34 32.181 27.4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M25.77 17.71s4.61.33 5.64 5.53"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 25.54,
    cy: 24.65,
    r: 11.97
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImprisonment);
export default __webpack_public_path__ + "static/media/Imprisonment.3054e031ef9a31356be1ea4da59b051b.svg";
export { ForwardRef as ReactComponent };